// import './HowItWorks.css';

// // How It Works Section
// export const HowItWorks = () => {
//   const steps = [
//     { num: 1, icon: '📷', title: 'Take a Photo', desc: 'Snap a picture of the item you want to sell.', imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_1.jpg?alt=media&token=c443b93a-ce87-4a16-8105-0b79f17240fb' },
//     { num: 2, icon: '🤖', title: 'AI Identifies', desc: 'Our AI recognizes the product and auto-selects the category.', imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_2.jpg?alt=media&token=e0ee9d2a-c358-4565-8b3c-6b3f7edae1b6' },
//     { num: 3, icon: '✏️', title: 'Review & Edit', desc: 'Verify or edit the auto-filled details and price.', imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_3.jpg?alt=media&token=8c28f283-970c-4281-9def-eecd84b27073' },
//     { num: 4, icon: '🎉', title: 'Post & Sell', desc: 'Publish your listing and start connecting with buyers.', imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_4.jpg?alt=media&token=c3d4132b-2398-4592-91de-5b7761b227b7' }
//   ];

//   return (
//     <section className="how-it-works">
//       <div className="container">
//         <h2 className="section-title">How It Works</h2>
//         <p className="section-subtitle">Sell your items in just 4 simple steps</p>
//         <div className="steps-container">
//           {steps.map((step) => (
//             <div key={step.num} className="step-card">
//               <img src={step.imgSrc} alt={step.title} className="step-image" />
//               <div className="step-number">{step.num}</div>
//               <h3>{step.title}</h3>
//               <p>{step.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };


import { useInView } from 'react-intersection-observer';
import './HowItWorks.css';

import phone1 from '../../assets/USP_In_Phone_1.png';
import phone2 from '../../assets/USP_In_Phone_2.png';
import phone3 from '../../assets/USP_In_Phone_3.png';
import phone4 from '../../assets/USP_In_Phone_4.png';

import arrowLeft from '../../assets/arr-1.png';
import arrowRight from '../../assets/arr-2.png';

export const HowItWorks = () => {
  const { ref, inView } = useInView({
    threshold: 0.10,
    triggerOnce: false,
  });

  const steps = [
    {
      num: 1,
      title: 'Take a Photo',
      desc: 'Snap a picture of the item you want to sell.',
      imgSrc:
        phone1,
    },
    {
      num: 2,
      title: 'AI Identifies',
      desc: 'Our AI recognizes the product and auto-selects the category.',
      imgSrc:
        phone2,
    },
    {
      num: 3,
      title: 'Review & Edit',
      desc: 'Verify or edit the auto-filled details and price.',
      imgSrc:
        phone3,
    },
    {
      num: 4,
      title: 'Post & Sell',
      desc: 'Publish your listing and start connecting with buyers.',
      imgSrc:
        phone4,
    },
  ];

  return (
    <section ref={ref} className="how-it-works">
      <div className="container">
        <h2 className={`howitworks-sec-title fade-in-section-dark ${inView ? 'is-visible' : ''}`}>
          How Qinto Works
        </h2>
        <h2 className={`howitworks-sec-subtitle fade-in-section-dark ${inView ? 'is-visible' : ''}`}>
          Just snap, review and post your listings, fast and free
        </h2>

        <div className="steps-container">
          {steps.map((step, idx) => (
            <div key={step.num} className="step-wrapper">
              <div
                className={`step-card fade-in-section ${inView ? 'is-visible' : ''}`}
                style={{ transitionDelay: `${idx * 320}ms` }}
              >
                {/* <div className="phone-glow" /> */}
                <img src={step.imgSrc} alt={step.title} className="step-image" />
                <h3>{step.num}. {step.title}</h3>
                <p>{step.desc}</p>
              </div>

              {/* Arrow between steps (desktop only) */}
              {/* {idx < steps.length - 1 && (
                <img
                  src={idx % 2 === 0 ? arrowRight : arrowLeft}
                  alt=""
                  className={`step-arrow-img fade-in-section ${inView ? 'is-visible' : ''
                    }`}
                  style={{ transitionDelay: `${idx * 150}ms` }}
                />
              )} */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
